import { combineReducers } from 'redux';
import list from './list';
import create from './create';
import del from './delete';
import setAsDefault from './setAsDefault';

export default combineReducers({ list, create, del, setAsDefault });
